import React from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, Divider, Paper, Typography } from '@material-ui/core';
import { KaizenChartForHooks } from '@kaizenplatform/kaizen-chartjs';
import { GetChartDocument } from '../../generated/graphql';
import { errorsVar } from '../../cache';
import { useDeleteChart } from '../../hooks';
import PageLayout from '../components/PageLayout';
import Lottie from '../components/Lottie';
import chartLoadingAnimation from '../../animations/chartloading.json';
var DestinationDetailsPage = function (props) {
    var _a;
    var classes = useStyles();
    var deleteChart = useDeleteChart(props.match.params.chartId).deleteChart;
    var _b = useQuery(GetChartDocument, {
        variables: {
            id: props.match.params.chartId,
            scope: { from: '2020-01-01', to: '2020-12-31' },
            breakdowns: null,
        },
    }), data = _b.data, loading = _b.loading;
    var errors = useReactiveVar(errorsVar);
    if (loading)
        return (React.createElement(Container, null,
            React.createElement(Paper, { className: classes.chartRoot },
                React.createElement(Lottie, { data: chartLoadingAnimation, loop: true, width: 300, height: 300 }),
                React.createElement(Typography, { className: classes.chartLoading, variant: "h6" },
                    ' ',
                    "Loading Charts...",
                    ' '))));
    if (data)
        return (React.createElement(PageLayout, null,
            React.createElement(Container, null,
                React.createElement(Paper, { className: classes.chartRoot },
                    React.createElement(Typography, { className: classes.chartTitle, variant: "h5" }, (_a = data.chart.name) !== null && _a !== void 0 ? _a : '[*no chart name*]'),
                    React.createElement(Button, { variant: "contained", style: { float: 'right' }, color: "primary", onClick: deleteChart }, "Delete this Chart"),
                    React.createElement(Divider, { className: classes.divider }),
                    React.createElement(KaizenChartForHooks, { chartData: data.chart, from: "", to: "", chartId: data.chart.id, autoHeight: !!(data.chart.type === 'TABLE') })))));
    return React.createElement(PageLayout, null);
};
var useStyles = makeStyles({
    tabsGrid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    chartLoading: {
        textAlign: 'center',
    },
    chartRoot: {
        padding: '10px 10px 60px',
        margin: 20,
    },
    chartTitle: {
        marginLeft: 10,
        float: 'left',
    },
    divider: {
        marginTop: 46,
    },
});
export default DestinationDetailsPage;
